<form [formGroup]="commentForm">
  <div class="bg-blue-2 d-flex al-center sp-between p-4">
    <div>
      <div>
        <span class="text-white fw-extrabold fs-4">Comentario</span>
      </div>
      <div>
        <span class="text-white fs-6 fw-regular">Escribe un comentario respecto a tu cliente</span>
      </div>
    </div>
    <div>
      <img src="assets/svg/Icon_close.svg" mat-dialog-close alt="">
    </div>
  </div>
  <mat-dialog-content class="p-4 d-flex flex-column content-form">
    <div>
      <div>
        <div class="mb-2">
          <span class="fs-6 fw-semibold">Comentario</span>
        </div>
        <textarea type="text" rows="5" formControlName="comment" placeholder="Ingrese un comentario" class="w-100 border rounded p-3"></textarea>
      </div>
    </div>
  </mat-dialog-content>
  <div class="p-4 text-end content-action">
    <mat-dialog-actions align="end">
      <button mat-flat-button class="bg-blue-2" (click)="saveComment()">
        <span class="fw-bold fs-5 text-white me-3">Guardar cambios</span>
        <img src="assets/svg/Icon_arrow_right_white.svg" alt="">
      </button>
    </mat-dialog-actions>
  </div>
</form>
<ng-container *ngIf="loader">
  <app-loader></app-loader>
</ng-container>